export const SITE_LISTING = "SITE_LISTING";
export const SITE_FILTERS = "SITE_FILTERS";
export const CHANGE_LOCATION= "CHANGE_LOCATION";
export const TASK_LISTING= "TASK_LISTING";
export const SITE_REPOSITORY = 'SITE_REPOSITORY';
export const CREATE_SITE_REPOSITORY = 'CREATE_SITE_REPOSITORY';
export const TAG_INFO = "TAG_INFO";
export const SITE_LISTING_FOR_ASSET = "SITE_LISTING_FOR_ASSET";
export const SITE_GATES_FOR_ASSET = "SITE_GATES_FOR_ASSET";
export const PARENT_MATERIALS = "PARENT_MATERIALS";
export const ASSETS = "ASSETS";
export const SAVE_ASSETS = "SAVE_ASSETS";
export const ASSET_INFO_DETAILS = "ASSET_INFO_DETAILS";
export const CONTRACT_GATES_FOR_ASSET = "CONTRACT_GATES_FOR_ASSET";
export const PARENT_MATERIALS_CONTRACT = "PARENT_MATERIALS_CONTRACT";
export const CLIENT_CONTRACT_MAPPING = "CLIENT_CONTRACT_MAPPING";
export const TAG_VEHICLE = "TAG_VEHICLE";
export const TAG_AUDIT = "TAG_AUDIT";
export const SITE_LISTING_MAINTENANCE = 'SITE_LISTING_MAINTENANCE';
export const PR_LISTING = 'PR_LISTING';
export const SITE_PR_LISTING = 'SITE_PR_LISTING';
export const SERVICES_QTY = 'SERVICES_QTY';
export const ACCEPT = "ACCEPT";
export const REJECT = "REJECT";
export const SERVICES_QTY_CONFIRMATON = "SERVICES_QTY_CONFIRMATON";
export const PR_CONFIRMATION_DETAILS = "PR_CONFIRMATION_DETAILS";
export const DISMANTLE_SITE = "DISMANTLE_SITE";
export const DISMANTLE_MRF = "DISMANTLE_MRF";
export const DISMANTLE_MRF_BY_SITE_ID = "DISMANTLE_MRF_BY_SITE_ID";
export const CONTRACT_DATE = "CONTRACT_DATE";
export const POS_REPLACE_RETURN = "POS_REPLACE_RETURN";
export const INSTALLATION_DATE_CHANGE_LIST="INSTALLATION_DATE_CHANGE_LIST";
export const INSTALLATION_DATE_CHANGE_DETAIL="INSTALLATION_DATE_CHANGE_DETAIL";
export const INSTALLATION_DATE_CHANGE_CREATE="INSTALLATION_DATE_CHANGE_CREATE";
export const INSTALLATION_DATE_CHANGE_APPROVAL="INSTALLATION_DATE_CHANGE_APPROVAL";
export const TAG_INFO_BY_VEHICLE_NO = "TAG_INFO_BY_VEHICLE_NO";
export const APPROVE_PR = "APPROVE_PR";
export const UPDATE_PR = "UPDATE_PR";

